export const getDeliveryLimitCitiesDropdownListV2 = (citiesList = []) => citiesList.map(({ name }) => ({
    label: name,
    value: name,
}));
//# sourceMappingURL=getDeliveryLimitCitiesDropdownListV2.js.map